/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables = Types.Exact<{
  input:
    | ReadonlyArray<Types.InvestorFirmRelationshipCreateInput>
    | Types.InvestorFirmRelationshipCreateInput;
}>;

export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation = {
  readonly __typename?: 'Mutation';
  readonly createInvestorRelationships?: {
    readonly __typename?: 'CreateInvestorRelationshipsPayload';
    readonly investorFirmRelationship?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    }> | null;
  } | null;
};

export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables =
  Types.Exact<{
    input: Types.AdminCreateInvestorRelationshipsInput;
  }>;

export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation = {
  readonly __typename?: 'Mutation';
  readonly adminCreateInvestorRelationships?: {
    readonly __typename?: 'AdminCreateInvestorRelationshipsPayload';
    readonly investorFirmRelationship?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    }> | null;
  } | null;
};

export type CrmManagement_AddSalesCoverage_FirmSearchQueryVariables = Types.Exact<{
  searchText: Types.Scalars['String']['input'];
  underwriterEmployeeId: Types.Scalars['UUID']['input'];
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type CrmManagement_AddSalesCoverage_FirmSearchQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly name: string;
      readonly firmKey?: string | null;
    }> | null;
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
    };
  } | null;
};

export type CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
  searchText: Types.Scalars['String']['input'];
  underwriterEmployeeId: Types.Scalars['UUID']['input'];
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type CrmManagement_AddSalesCoverage_AdminFirmSearchQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorFirmsGrid?: {
    readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly name: string;
      readonly firmKey?: string | null;
    }> | null;
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
    };
  } | null;
};

export type InvestorFirmSearchItemFragment = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly id: string;
  readonly name: string;
  readonly firmKey?: string | null;
};

export const InvestorFirmSearchItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearchItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddSalesCoverage_CreateUnderwriterEmployeeRelationships' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'InvestorFirmRelationshipCreateInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvestorRelationships' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'input' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationFn =
  Apollo.MutationFunction<
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >;

/**
 * __useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation__
 *
 * To run a mutation, you first call `useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesCoverageCreateUnderwriterEmployeeRelationshipsMutation, { data, loading, error }] = useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >(AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsDocument, options);
}
export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationHookResult = ReturnType<
  typeof useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation
>;
export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationResult =
  Apollo.MutationResult<AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation>;
export type AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationOptions =
  Apollo.BaseMutationOptions<
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >;
export const AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationships' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminCreateInvestorRelationshipsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminCreateInvestorRelationships' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationFn =
  Apollo.MutationFunction<
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >;

/**
 * __useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation__
 *
 * To run a mutation, you first call `useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesCoverageAdminCreateUnderwriterEmployeeRelationshipsMutation, { data, loading, error }] = useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >(AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsDocument, options);
}
export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationHookResult =
  ReturnType<typeof useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation>;
export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationResult =
  Apollo.MutationResult<AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation>;
export type AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationOptions =
  Apollo.BaseMutationOptions<
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >;
export const CrmManagement_AddSalesCoverage_FirmSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AddSalesCoverage_FirmSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'underwriterEmployeeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'firmKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'linkedCmgEntityKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'linkedCmgEntityName' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'salesCoverage' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'none' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'employeeId' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'underwriterEmployeeId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmSearchItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearchItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AddSalesCoverage_FirmSearchQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AddSalesCoverage_FirmSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AddSalesCoverage_FirmSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AddSalesCoverage_FirmSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      underwriterEmployeeId: // value for 'underwriterEmployeeId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCrmManagement_AddSalesCoverage_FirmSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  > &
    (
      | { variables: CrmManagement_AddSalesCoverage_FirmSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_FirmSearchDocument, options);
}
export function useCrmManagement_AddSalesCoverage_FirmSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_FirmSearchDocument, options);
}
// @ts-ignore
export function useCrmManagement_AddSalesCoverage_FirmSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddSalesCoverage_FirmSearchQuery,
  CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
>;
export function useCrmManagement_AddSalesCoverage_FirmSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddSalesCoverage_FirmSearchQuery,
        CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddSalesCoverage_FirmSearchQuery | undefined,
  CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
>;
export function useCrmManagement_AddSalesCoverage_FirmSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddSalesCoverage_FirmSearchQuery,
        CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AddSalesCoverage_FirmSearchQuery,
    CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_FirmSearchDocument, options);
}
export type CrmManagement_AddSalesCoverage_FirmSearchQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_FirmSearchQuery
>;
export type CrmManagement_AddSalesCoverage_FirmSearchLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_FirmSearchLazyQuery
>;
export type CrmManagement_AddSalesCoverage_FirmSearchSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_FirmSearchSuspenseQuery
>;
export type CrmManagement_AddSalesCoverage_FirmSearchQueryResult = Apollo.QueryResult<
  CrmManagement_AddSalesCoverage_FirmSearchQuery,
  CrmManagement_AddSalesCoverage_FirmSearchQueryVariables
>;
export const CrmManagement_AddSalesCoverage_AdminFirmSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AddSalesCoverage_AdminFirmSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'underwriterEmployeeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'firmKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'linkedCmgEntityKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'linkedCmgEntityName' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'salesCoverage' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'none' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'employeeId' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'underwriterEmployeeId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmSearchItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearchItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      searchText: // value for 'searchText'
 *      underwriterEmployeeId: // value for 'underwriterEmployeeId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  > &
    (
      | { variables: CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_AdminFirmSearchDocument, options);
}
export function useCrmManagement_AddSalesCoverage_AdminFirmSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_AdminFirmSearchDocument, options);
}
// @ts-ignore
export function useCrmManagement_AddSalesCoverage_AdminFirmSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
  CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
>;
export function useCrmManagement_AddSalesCoverage_AdminFirmSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
        CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddSalesCoverage_AdminFirmSearchQuery | undefined,
  CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
>;
export function useCrmManagement_AddSalesCoverage_AdminFirmSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
        CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
    CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
  >(CrmManagement_AddSalesCoverage_AdminFirmSearchDocument, options);
}
export type CrmManagement_AddSalesCoverage_AdminFirmSearchQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_AdminFirmSearchQuery
>;
export type CrmManagement_AddSalesCoverage_AdminFirmSearchLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_AdminFirmSearchLazyQuery
>;
export type CrmManagement_AddSalesCoverage_AdminFirmSearchSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AddSalesCoverage_AdminFirmSearchSuspenseQuery
>;
export type CrmManagement_AddSalesCoverage_AdminFirmSearchQueryResult = Apollo.QueryResult<
  CrmManagement_AddSalesCoverage_AdminFirmSearchQuery,
  CrmManagement_AddSalesCoverage_AdminFirmSearchQueryVariables
>;
